export const manageEmployeesContext = require.context(
  ".",
  true,
  /\_controller.js$/
);
